import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import getPreview from 'action-creators/checkout/get-preview';

const propTypes = {
  couponAmount: PropTypes.number.isRequired,
  getPreview: PropTypes.func.isRequired,
};

class ClearCouponCode extends Component {
  constructor(props) {
    super(props);

    this.handleRemoveCoupon = this.handleRemoveCoupon.bind(this);
  }

  handleRemoveCoupon() {
    this.props.getPreview({ couponCode: null, autoApplyCoupon: false });
  }

  render() {
    if (this.props.couponAmount > 0) {
      return (
        <a className="remove-coupon" onClick={this.handleRemoveCoupon}>
          Remove Code
        </a>
      );
    }

    return null;
  }
}

ClearCouponCode.propTypes = propTypes;

const mapStateToProps = (state) => {
  const {
    couponAmount,
  } = state.checkout;

  return {
    couponAmount,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({ getPreview }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(ClearCouponCode);
